<template>
    <div class="contain">
      <div class="popup">
        <div class="close-wrapper">
          <slot name="close"></slot>
        </div>
        <div class="popup-title">
          {{ popupTitle }}
        </div>
        <slot name="title"></slot>
        <slot name="content"></slot>
        <slot name="footer"></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "WalkmanPlayer",
  };
  </script>
  
  <script setup>
  /* eslint-disable no-unused-vars */
  import { ref, onMounted, nextTick, onUnmounted, computed, defineProps } from "vue";

  defineProps({
    popupTitle: {
      type: String,
      default: '',
    },
  });
  </script>
  
  <style scoped lang="scss">
  .contain {
    position: fixed; // 弹窗遮罩保持 fixed，覆盖整个视口
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // top/left/right/bottom 已足够覆盖整个视口，无需 width/height
    background: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    z-index: 9999;
    margin: 0;
    padding: 0;
  
    * {
      -webkit-tap-highlight-color: transparent;
      -webkit-touch-callout: none;
    }
  
    .popup {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 709px;
      height: 451px;
      padding: 40px 20px 10px;
      box-sizing: border-box;
      background: linear-gradient(
        180deg,
        #cbb8ff 0%,
        #eee8ff 6%,
        #ffffff 17%,
        #ffffff 100%
      );
      border-radius: 30px 30px 0px 0px;

      .close-wrapper {
        position: absolute;
        z-index: 10001;
        top: 16px;
        right: 16px;
      }

      .popup-title {
        position: absolute;
        top: 23px;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        font-size: 16px;
        color: #333333;
      }
    }
  }
  </style>
  